






























import "./project-setup.less";
import Vue from "vue";
import iForm from "iView";
import moment from "moment";
import { Model } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import UserAvatar from "../common/user-avatar.vue";
let _ = require("lodash");

export default Vue.extend({
  name: "CardMembers",
  components: { UserAvatar },
  props: {
    card: Object,
    showEditor: Boolean,
  },
  data() {
    return {
      selectedMemberIds: [],
      members: [],
    };
  },
  watch: {
    showModal(newVal) {
      let context = this as any;

      if (newVal === true) {
        let members = context.currentProject ? context.currentProject.members : [];
        context.selectedMemberIds = context.card && context.card.selectedMemberIds ? context.card.selectedMemberIds : [];
        context.members = members.map((member) => {
          let result = Object.assign({}, member);

          result.selected = !!_.find(context.selectedMemberIds, function (id) {
            return id === member.memberId;
          });

          return result;
        });
      }
    },
  },
  computed: {
    ...mapState("project", ["currentProject"]),
    ...mapGetters("project", ["canEditCurrentProject"]),
    showModal(): boolean {
      return this.showEditor;
    },
  },
  methods: {
    handleSave($event) {
      let context = this as any;
      let selectedMemberIds = context.members
        .filter((member) => member.selected === true)
        .map((member) => {
          return member.memberId;
        });
      this.$emit("save", selectedMemberIds, $event);
    },
    handleClick(member) {
      member.selected = !member.selected;
    },
  },
});
